import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { actionCreators } from './store.js';
import Transaction from './Transaction';

class TransactionsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      fee: false,
      payments: false,
      oneOff: false,
      refund: false,
      startDate: null,
      endDate: null,
      transactions: {},
      adfitNo: '',
    };
    this.feeTypes = [
      'DF',
      'PV',
      'SV',
      'CC',
      'CM',
      'CO',
      'TC',
      'EO',
      'AF',
      'DO',
      'JG',
      'NO',
      'FC',
      'AO',
      'ST',
      'AT',
      'CF',
      'DC',
      'EF',
      'MS',
      'PF',
      'SU',
      'TF',
    ];
    this.paymentTypes = ['PY', 'DP', 'PD'];
  }

  componentDidMount = () => {
    const { match } = this.props;
    let matchSplit = match.url.split('/');
    let tab = matchSplit.length === 4 ? matchSplit[3] : '';
    this.setState({ tab: tab });
    this.setState({ adfitNo: match.params.adfitNo });
    this.loadTransations(match.params.adfitNo);
  };

  loadTransations = (adfitNo) => {
    const { getAllGroupedTransactions } = this.props;
    if (this.shouldReloadData()) {
      getAllGroupedTransactions(adfitNo);
    }
  };

  shouldReloadData = () => {
    //only reload if adfitNo from query string differs from the one in store
    const { match, transactions } = this.props; //query string
    return transactions.groupedTransactions[0]
      ? transactions.groupedTransactions[0].adfitNo !== match.params.adfitNo
      : true;
  };

  handlePageClick = (data) => {
    window.scroll(0, 0);
    this.setState({ currentPage: data.selected });
  };

  validTranDate = (from, to, tranDate) => {
    var date = moment(tranDate);
    let mDate = date.toDate();
    if ((from && !to && date > from) || (!from && to && date < to)) return true;
    else if (!from && !to) return true;
    else if (from <= mDate && mDate <= to) return true;
    else return false;
  };

  handleFilterClick = () => {
    let transData = this.props.transactions.groupedTransactions;
    let { accountInfor } = this.props.transactions;
    let filteredTrans = [];
    let { fee, payments, refund, oneOff, startDate, endDate } = this.state;

    if (!fee && !payments && !refund && !oneOff && !startDate && !endDate) {
      filteredTrans = transData;
      this.setState({
        transactions: {
          groupedTransactions: filteredTrans,
          accountInfor: accountInfor,
        },
      });
      return;
    }

    transData.forEach((tran) => {
      let validTranDate = this.validTranDate(
        startDate,
        endDate,
        tran.transDate
      );

      if (!fee && !payments && !refund && !oneOff && validTranDate) {
        filteredTrans.push(tran);

        return;
      }

      if (fee && this.feeTypes.includes(tran.transcode) && validTranDate) {
        filteredTrans.push(tran);
        return;
      }

      if (
        payments &&
        this.paymentTypes.includes(tran.transcode) &&
        validTranDate
      ) {
        filteredTrans.push(tran);
        return;
      }
      if (refund && tran.transcode === 'RF' && validTranDate) {
        filteredTrans.push(tran);
        return;
      }
      if (oneOff && tran.transcode === 'OP' && validTranDate) {
        filteredTrans.push(tran);
        return;
      }
    });

    this.setState({
      transactions: {
        groupedTransactions: filteredTrans,
        accountInfor: accountInfor,
      },
    });
  };

  handleFeeChange = (event, isChecked) => {
    this.setState({ fee: isChecked });
  };

  handlePaymentsChange = (event, isChecked) => {
    this.setState({ payments: isChecked });
  };

  handleOneOffChange = (event, isChecked) => {
    this.setState({ oneOff: isChecked });
  };
  handleRefundChange = (event, isChecked) => {
    this.setState({ refund: isChecked });
  };

  handleStartDateChange = (date) => {
    this.setState({ startDate: date });
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: date });
  };

  handleClearClick = () => {
    this.setState({
      fee: false,
      payments: false,
      refund: false,
      oneOff: false,
      startDate: null,
      endDate: null,
    });
  };

  render = () => {
    const { localisation, transactions } = this.props;

    return (
      <Transaction
        localisation={localisation}
        transData={
          this.shouldReloadData()
            ? {}
            : this.state.transactions.hasOwnProperty('groupedTransactions')
            ? this.state.transactions
            : transactions
        }
        handleFilterClick={this.handleFilterClick}
        handleFeeChange={this.handleFeeChange}
        handlePaymentsChange={this.handlePaymentsChange}
        handleOneOffChange={this.handleOneOffChange}
        handleRefundChange={this.handleRefundChange}
        handleStartDateChange={this.handleStartDateChange}
        handleEndDateChange={this.handleEndDateChange}
        handleClearClick={this.handleClearClick}
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        fee={this.state.fee}
        payments={this.state.payments}
        oneOff={this.state.oneOff}
        refund={this.state.refund}
        onPageChange={this.handlePageClick}
        currentPage={this.state.currentPage}
      />
    );
  };
}

TransactionsContainer.propTypes = {
  localisation: PropTypes.object,
  transactions: PropTypes.array,
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      localisation: state.localisation,
      transactions: state.transactions,
    }),
    {
      getAllGroupedTransactions: actionCreators.getAllGroupedTransactions,
      resetTransPage: actionCreators.resetTransPage,
    }
  )
)(TransactionsContainer);
